/* Shared discount apply for cart drawer + cart page. Uses /cart/update.js discount param (Shopify Editions 25) + Section Rendering API so it applies inline with applied/invalid feedback, no page navigation. */
(function () {
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function secInner(html, sel) {
    try { var d = new DOMParser().parseFromString(html, 'text/html'); var e = d.querySelector(sel); return e ? e.innerHTML : null; }
    catch (_) { return null; }
  }
  function refresh(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var di = secInner(sections['cart-drawer'], '.drawer__inner');
      var lv = document.querySelector('#CartDrawer .drawer__inner');
      if (di != null && lv) lv.innerHTML = di;
    }
    ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'].forEach(function (id) {
      if (sections[id]) {
        var w = document.getElementById('shopify-section-' + id);
        if (w) w.innerHTML = sections[id];
      }
    });
  }
  window.applyStoreDiscount = function (code, containerSel) {
    code = (code || '').trim();
    function setMsg(t, state) {
      var m = document.querySelector(containerSel + ' [data-discount-msg]');
      if (m) { m.textContent = t; m.setAttribute('data-state', state); }
    }
    if (!code) { setMsg('Please enter a code', 'err'); return; }
    setMsg('Applying…', 'pending');
    fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code, sections: ['cart-drawer', 'main-cart-items', 'main-cart-footer', 'cart-icon-bubble'], sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      var ok = (cart.discount_codes || []).some(function (d) { return d.code && d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
      refresh(cart.sections);
      if (ok) { setMsg('✓ “' + code + '” applied', 'ok'); }
      else { setMsg('“' + code + '” is not a valid code', 'err'); }
    }).catch(function () { setMsg('Could not apply — please try again', 'err'); });
  };
})();
